import { Component, Input, OnChanges, Output, EventEmitter } from '@angular/core';
import { PublicEventInfo, PublicTimelineItem } from 'globals/store/public.model';
import publicHelpers from 'src/app/helpers/public-helpers';
import { GalleryCardComponent } from './gallery-card.component';
import { CommonModule } from '@angular/common';
import { EntityProfileComponent } from 'src/app/components/entities/program-entity-profile.component';
@Component({
    selector: 'sponsor-gallery',
    template: `
<div class="empty-entities-note" *ngIf="isPreview && !joiEvent.sponsorGroupings?.length" [innerHTML]="publicHelpers.strWithBreak(emptyMessage)"></div>
<div *ngIf="!selectedSponsorId && !!joiEvent?.sponsorGroupings" class="sponsors-holder">
  <div class="sponsor-group-holder" *ngFor="let sponsorGroup of joiEvent.sponsorGroupings">
    <div class="type-name" *ngIf="sponsorGroup.sponsorTypeId && !hideTypes">{{ joiEvent.sponsorTypes[sponsorGroup.sponsorTypeId]?.name }}</div>
    <hr *ngIf="!sponsorGroup.sponsorTypeId && joiEvent.sponsorGroupings.length > 1 && !hideTypes" class="nameless-divider"> <!-- <== uncategorized sponsors -->
    <div class="cards-holder">
      <ng-container *ngFor="let sponsorId of sponsorGroup.ids">
        <gallery-card *ngIf="joiEvent.profileSponsors[sponsorId] as sponsor" [hideName]="true" [entity]="sponsor" (click)="showSponsor(sponsor.id)"></gallery-card>
      </ng-container>
    </div>
  </div>
</div>
<entity-profile 
  *ngIf="selectedSponsorId && joiEvent.profileSponsors[selectedSponsorId] as sponsor" 
  backLabel="Sponsors" 
  [backLabel]="entityName" 
  [labelMap]="joiEvent.sponsor_labels"
  [sessionsTitle]="'Sessions sponsored by ' + sponsor.name + ':'"
  [sessions]="sessions"
  [sponsor]="sponsor"
  [programTexts]="programTexts"
  [hideImages]="!sponsor?.logoUrl || !!sponsor.hideLogo"
  [name]="sponsor.name"
  [hideLabels]="sponsor.hideLabels"
  [labels]="sponsor.labels"
  [social]="sponsor.social"
  [description]="sponsor.description"
  [logoUrl]="sponsor.fullLogoUrl || sponsor.logoUrl"
  [callToAction]="sponsor.callToAction"
  [callToActionUrl]="sponsor.callToActionUrl"
  [joiEvent]="joiEvent"
  (goBack)="selectedSponsorId = null"
></entity-profile>
`,
    styleUrls: ['./sponsor-gallery.scss'],
    standalone: true,
    imports: [GalleryCardComponent, EntityProfileComponent, CommonModule],
})
export class SponsorGalleryComponent implements OnChanges {
  @Input() joiEvent: PublicEventInfo
  @Input() timeline: PublicTimelineItem[][]
  @Input() programTexts = {}
  @Input() hideTypes = false
  @Input() hideSessions = false
  @Input() isPreview = false
  @Input() entityName
  publicHelpers = publicHelpers
  emptyMessage = "Note: This sponsors page has no content to display and will be hidden when you publish.\n\nTo include this page, add sponsors or adjust the <b>Filter Timeline</b> controls."
  selectedSponsorId: string
  sessions: PublicTimelineItem[] = []
  @Output() scrollUp: EventEmitter<void> = new EventEmitter()

  showSponsor(sponsorId: string) {
    this.selectedSponsorId = sponsorId
    this.setTimeline()
    this.scrollUp.emit()
  }

  ngOnChanges() {
    if (this.selectedSponsorId) this.setTimeline()
  }

  setTimeline() {
    this.sessions = []
    if (this.hideSessions) return
    this.timeline.forEach(day => day.forEach(session => {
      if (session.sponsorIds.includes(this.selectedSponsorId)) this.sessions.push(session)
    }))
  }

}




